<permission-checker [roles]="roles" (contentInit)="initContent()" (rolesLoaded)="rolesUpdated($event)">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar exam-toolbar">
      <mat-toolbar-row class="toolbar-row">
        <app-logo [showText]="false" class="logo"></app-logo>

        <mat-spinner *ngIf="!contest && !contestLoadFailed;else contestName" color="primary"
                     diameter="40"></mat-spinner>
        <ng-template #contestName>
          <div class="contest-title" [class.mobile]="mobileView">{{contest?.name}}</div>
        </ng-template>

        <div class="fill-space"></div>

        <mat-spinner *ngIf="!user;else userName" color="primary" diameter="40"></mat-spinner>
        <ng-template #userName>
          <div *ngIf="!mobileView" class="user-name">{{user?.firstName}} {{user?.lastName}}</div>
        </ng-template>

        <mat-icon *ngIf="((!taskType && !task) || taskLoadFailed) || timeIsUp || manuallyFinished" class="exit-exam-btn"
                  (click)="exitExam()">logout
        </mat-icon>
      </mat-toolbar-row>

      <mat-toolbar-row *ngIf="task && !manuallyFinished" class="notification-toolbar">
        <div class="fill-space"></div>

        <div>
          <app-timer *ngIf="progress && progress.startedAt" #timer
                     [timerUntil]="getContestEndTime"
                     [timerFinished]="manuallyFinished"
                     (clientShiftUpdated)="handleClientTimeShiftUpdated($event)"
                     (clientShiftDetected)="handleClientTimeShift($event)"
                     (timerEnded)="handleTimerEnded()"></app-timer>
        </div>

        <div class="fill-space"></div>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page" [class.with-notification]="task && !manuallyFinished">
      <mat-spinner *ngIf="inProgress" [diameter]="40" class="center-middle" color="primary"></mat-spinner>

      <!--  Contest data load failed (incorrect URL?)   -->
      <app-no-content *ngIf="!inProgress && !contest && contestLoadFailed"
                      class="color-warn"
                      title="Contest details fetch has failed"
                      i18n-title="Notifications|Contest details fetch has failed message@@notifications-contest-details-fetch-failed-error">
        <div class="text-normal-color"
             i18n="Contest Exam|Contest details fetch failed details@@contest-exam-contest-details-fetch-failed-details">
          The system was not able to locate the contest you were trying to load. If you are using a direct contest URL,
          ensure that it is correct. Please try to get back to the home page and open the contest page again. If you are
          sure that the URL is valid, please get in touch with the contest host.
        </div>

        <app-button label="Available Contests"
                    i18n-label="Navigation|Available Contests title@@navigation-available-contests-title"
                    class="center available-contests-cta"
                    color="primary"
                    (clicked)="showAvailableContests()">
        </app-button>
      </app-no-content>

      <div *ngIf="!inProgress && contest && !task && (!progress || !progress.startedAt)"
           fxLayout="column wrap" fxFlexAlign="center" class="full-height">
        <div class="contest-info full-width">
          <div>
            <span class="text-disabled-color"
                  i18n="Contest Enrol Modal|Contest Enrol period section title@@contest-enrol-modal-period-section-title">
              Period:
            </span>&nbsp;
            {{contest.startsAt | date: mobileView ? 'short' : 'medium'}}
            - {{contest.endsAt | date: mobileView ? 'short' : 'medium'}}
          </div>
          <h2 *ngIf="taskGrade" class="color-primary">
            {{localizeGrade(taskGrade)}}
          </h2>

          <!--          <div>-->
          <!--            <span class="text-disabled-color"-->
          <!--                  i18n="Contest Enrol Modal|Contest Enrol duration section title@@contest-enrol-modal-duration-section-title">-->
          <!--              Duration:-->
          <!--            </span>&nbsp;-->

          <!--            <span *ngIf="contest.config && contest.config.duration;else noDuration">{{contest.config.duration}}-->
          <!--              &thinsp;-->
          <!--              <ng-container-->
          <!--                i18n="General|Time interval (minutes) term@@general-time-interval-minutes-term">minutes</ng-container>-->
          <!--            </span>-->
          <!--            <ng-template #noDuration>-->
          <!--              <ng-container i18n="General|No data provided@@general-no-data-provided">[no data]</ng-container>-->
          <!--            </ng-template>-->
          <!--          </div>-->
          <!--          </div>-->

        </div>

        <!--  Preview mode  -->
        <app-no-content *ngIf="previewMode"
                        class="color-green"
                        [padSpace]="true"
                        title="Contest Preview Mode"
                        i18n-title="Contest Exam|Contest preview mode title@@contest-exam-contest-preview-mode-title">
          <div class="text-normal-color preview-description" ngClass.lt-md="small-screen"
               i18n="Contest Preview|Contest Preview details@@contest-preview-details">
            You will be able to preview the contest as students will see it. Please note that you can answer questions,
            but responses are not recorded and scored.
          </div>
        </app-no-content>

        <div class="fill-space"></div>

        <div class="notifications full-width">
          <!--  Grade is not configured  -->
          <app-no-content *ngIf="!inProgress && user && !taskGrade && !previewMode"
                          class="color-warn"
                          [padSpace]="false"
                          title="School grade is not configured"
                          i18n-title="Contest Exam|School grade is not configured title@@contest-exam-school-grade-not-configured-title"
                          details="Please go to your profile page and select your school grade"
                          i18n-details="Contest Exam|School grade is not configured details@@contest-exam-school-grade-not-configured-details"></app-no-content>

          <!--  Contest ended  -->
          <app-no-content *ngIf="contest.endsAt && contest.endsAt <= today"
                          class="color-warn"
                          [padSpace]="false"
                          title="contest ended"
                          i18n-title="Contest Enrol Modal|Contest ended info message@@contest-enrol-contest-ended-info-message">

            <div *ngIf="previewMode && !taskType && taskGrade">
              <div *ngIf="availableTasks && taskGrade && availableTasks[taskGrade]; else noAvailableTasks">
                <div *ngFor="let data of availableTasks[taskGrade] | keyvalue" class="mat-small">
                  <div class="available-languages">
                    <span class="text-disabled-color"
                          i18n="Contest Exam|Task available languages title@@contest-exam-task-available-languages-title">
                      Languages:
                    </span>
                    {{getAvailableLanguages(data.value)}}
                  </div>
                  <app-button [label]="displayTaskType(data.key)"
                              class="task-cta with-description"
                              color="primary"
                              (clicked)="selectTaskType(data.key)">
                  </app-button>

                  <span class="text-disabled-color task-cta-desc">({{displayTaskDescription(data.key)}})</span>
                </div>
              </div>
              <ng-template #noAvailableTasks>
                <div class="color-warn no-available-tasks-message"
                     i18n="Contest Exam|No tasks available message@@contest-exam-no-tasks-available-message"
                >No tasks available, please contact a contest organizer
                </div>
              </ng-template>
            </div>
          </app-no-content>

          <!--  Contest in progress  -->
          <app-no-content
            *ngIf="taskGrade && !taskType && (contest.startsAt && contest.endsAt && contest.startsAt <= today && contest.endsAt > today && (userCanTakePart || previewMode))"
            class="color-green"
            [padSpace]="false"
            title="contest in progress"
            i18n-title="Contest Enrol Modal|Contest in progress info message@@contest-enrol-contest-in-progress-info-message"
            details="Please select one of the available task types to proceed:"
            i18n-details="Contest Exam|Select task type details@@contest-exam-select-task-type-details">

            <div *ngIf="availableTasks && taskGrade && availableTasks[taskGrade]; else noAvailableTasks">
              <div *ngFor="let data of availableTasks[taskGrade] | keyvalue" class="mat-small">
                <div class="available-languages">
                  <span class="text-disabled-color"
                        i18n="Contest Exam|Task available languages title@@contest-exam-task-available-languages-title">
                    Languages:
                  </span>
                  {{getAvailableLanguages(data.value)}}
                </div>
                <app-button [label]="displayTaskType(data.key)"
                            class="task-cta with-description"
                            color="primary"
                            (clicked)="selectTaskType(data.key)">
                </app-button>

                <span class="text-disabled-color task-cta-desc">({{displayTaskDescription(data.key)}})</span>
              </div>
            </div>
            <ng-template #noAvailableTasks>
              <div class="color-warn no-available-tasks-message"
                   i18n="Contest Exam|No tasks available message@@contest-exam-no-tasks-available-message"
              >No tasks available, please contact a contest organizer
              </div>
            </ng-template>
          </app-no-content>

          <!--  Future Contest  -->
          <app-no-content *ngIf="previewMode && taskGrade && contest.startsAt && contest.startsAt > today"
                          class="color-orange"
                          [padSpace]="false"
                          title="contest not started yet"
                          i18n-title="Contest Enrol Modal|Contest not started info message@@contest-enrol-contest-not-started-info-message">

            <div *ngIf="previewMode && !taskType && taskGrade">
              <div *ngIf="availableTasks && taskGrade && availableTasks[taskGrade]; else noAvailableTasks">
                <div *ngFor="let data of availableTasks[taskGrade] | keyvalue" class="mat-small">
                  <div class="available-languages">
                    <span class="text-disabled-color"
                          i18n="Contest Exam|Task available languages title@@contest-exam-task-available-languages-title">
                      Languages:
                    </span>
                    {{getAvailableLanguages(data.value)}}
                  </div>
                  <app-button [label]="displayTaskType(data.key)"
                              class="task-cta with-description"
                              color="primary"
                              (clicked)="selectTaskType(data.key)">
                  </app-button>

                  <span class="text-disabled-color task-cta-desc">({{displayTaskDescription(data.key)}})</span>
                </div>
              </div>
              <ng-template #noAvailableTasks>
                <div class="color-warn no-available-tasks-message"
                     i18n="Contest Exam|No tasks available message@@contest-exam-no-tasks-available-message"
                >No tasks available, please contact a contest organizer
                </div>
              </ng-template>
            </div>
          </app-no-content>

          <!--  Grade is not configured (in preview)  -->
          <app-no-content *ngIf="previewMode && !inProgress && user && !taskGrade"
                          class="color-warn"
                          [padSpace]="false"
                          title="School grade is not configured"
                          i18n-title="Contest Exam|School grade is not configured title@@contest-exam-school-grade-not-configured-title"
                          details="School grade will be selected based on the configuration in the student's profile"
                          i18n-details="Contest Exam|School grade will be selected for student@@contest-exam-school-grade-will-be-selected-for-student">
            <item-select [roles]="roles"
                         label="Task Grade:"
                         i18n-label="Contest Tasks Editor|Contest task grade input label@@contest-tasks-editor-task-grade-input-label"
                         class="grade-select"
                         [compareWith]="compareTaskGrades"
                         [displayWith]="displayTaskGrade"
                         [loadWith]="loadTaskGrades"
                         [selectedItem]="taskGrade"
                         [disabled]="inProgress || !previewMode"
                         (selected)="changeTaskGrade($event)"></item-select>
          </app-no-content>

          <!--  Locale not selected (and we have some selection)  -->
          <div *ngIf="!inProgress && taskType && !taskLocale && !timeIsUp && !manuallyFinished && !singleOption"
               fxFlexAlign="center" class="full-height full-width">
            <app-no-content [padSpace]="false"
                            title="Please select your preferred language for tasks"
                            i18n-title="Contest Exam|Select task locale title@@contest-exam-select-locale-title"
                            details="Questions, answers and any support materials available will be translated using the selected language"
                            i18n-details="Contest Exam|Select task locale details@@contest-exam-select-locale-details">
              <div *ngFor="let locale of availableLanguages" class="locale-select-block">
                <app-button [label]="localizeLocale(locale)"
                            class="task-cta"
                            color="primary"
                            (clicked)="selectTaskLocale(locale)">
                </app-button>
              </div>

              <mat-icon class="text-disabled-color interactive-cursor"
                        (click)="taskType = undefined">keyboard_backspace
              </mat-icon>
            </app-no-content>
          </div>
          <!--  Locale not selected (single selection)  -->
          <div *ngIf="!inProgress && taskType && !taskLocale && !timeIsUp && !manuallyFinished && singleOption"
               fxFlexAlign="center" class="full-height full-width">
            <app-no-content [padSpace]="false"
                            title="Contest Start"
                            i18n-title="Contest Exam|Start contest title@@contest-exam-start-contest-title"
                            details="Please use the button below to start the contest"
                            i18n-details="Contest Exam|Start contest details@@contest-exam-start-contest-details">
              <div class="locale-select-block">
                <app-button label="Start"
                            i18n-label="General|Start action label@@general-start-action-label"
                            class="task-cta"
                            color="primary"
                            (clicked)="selectTaskLocale(availableLanguages[0])">
                </app-button>
              </div>
            </app-no-content>
          </div>

          <!--  Cannot take contest  -->
          <app-no-content *ngIf="!previewMode && !userCanTakePart;else userCanTakeContest"
                          class="color-warn"
                          [padSpace]="false"
                          title="You cannot take this contest"
                          i18n-title="Contest Exam|Not enrolled or not paid message@@contest-exam-not-enrolled-or-not-paid-message"
                          details="You either haven't enrolled in this contest, or your payment was not successful"
                          i18n-details="Contest Exam|Not enrolled or not paid details@@contest-exam-not-enrolled-or-not-paid-details">

            <app-button label="Available Contests"
                        i18n-label="Navigation|Available Contests title@@navigation-available-contests-title"
                        class="center available-contests-cta"
                        color="primary"
                        (clicked)="showAvailableContests()">
            </app-button>
          </app-no-content>
          <ng-template #userCanTakeContest>
            <app-no-content *ngIf="!previewMode && contest && contest.startsAt && contest.startsAt > today"
                            class="color-green"
                            [padSpace]="false"
                            title="You can take this contest when it begins"
                            i18n-title="Contest Exam|Can take part but not started yet message@@contest-exam-can-take-part-but-not-started-yet-message"
                            details="Please come back when the contest is scheduled to start to take part"
                            i18n-details="Contest Exam|Can take part but not started yet details@@contest-exam-can-take-part-but-not-started-yet-details"
            ></app-no-content>
          </ng-template>
        </div>

        <div class="fill-space"></div>
      </div>

      <!--  Task load failed  -->
      <div *ngIf="!inProgress && taskLoadFailed">
        <app-no-content class="color-orange center"
                        fxFlex="60%" fxFlex.lt-sm="90%" fxFlex.sm="90%"
                        title="Contest task details can be fetched only within the contest period for enrolled participants"
                        i18n-title="Notifications|Contest task details fetch not allowed message@@notifications-contest-task-details-fetch-not-allowed-error"></app-no-content>
      </div>

      <div *ngIf="!inProgress && task && !timeIsUp && !manuallyFinished" fxFlexAlign="center"
           class="full-height full-width">
        <mat-tab-group headerPosition="above" dynamicHeight class="exam-questions-tab-group"
                       [(selectedIndex)]="selectedQuestion"
                       (selectedTabChange)="handleQuestionChange()">
          <div *ngFor="let section of taskSections">
            <mat-tab *ngFor="let question of section.questions">
              <ng-template mat-tab-label>
                <mat-icon *ngIf="answeredQuestions.has(question.id || '')" class="color-green">done</mat-icon>
                {{getQuestionLabel(section.index, question.index)}}
              </ng-template>
              <contest-question #contestQuestion
                                [question]="question"
                                [section]="section"
                                [editMode]="false"
                                [localizeMode]="false"
                                [examMode]="true"
                                [backEnabled]="canNavigateBack(section, question)"
                                (back)="selectedQuestion = selectedQuestion - 1"
                                [forwardEnabled]="canNavigateForward(section, question)"
                                (forward)="selectedQuestion = selectedQuestion + 1"
                                (answered)="handleQuestionAnswer(section, question, $event, contestQuestion)"></contest-question>
            </mat-tab>
          </div>

          <div>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon color="primary">sports_score</mat-icon>
                <ng-container i18n="Contest Exam|Finish tab title@@contest-exam-finish-tab-title">Completion
                </ng-container>
              </ng-template>

              <app-no-content title="Complete contest"
                              i18n-title="Contest Exam|Complete contest prompt title@@contest-exam-complete-contest-prompt-title"
                              details="You can still change your answers, or you can complete your contest if you are done"
                              i18n-details="Contest Exam|Complete contest prompt details@@contest-exam-complete-contest-prompt-details">
                <app-button label="Complete Contest"
                            i18n-label="Contest Exam|Complete contest btn title@@contest-exam-complete-contest-btn-title"
                            class="complete-cta"
                            color="primary"
                            (clicked)="handleCompleteContest()">
                </app-button>
              </app-no-content>
            </mat-tab>
          </div>
        </mat-tab-group>
      </div>

      <div *ngIf="!inProgress && task && (timeIsUp || manuallyFinished)" fxLayout="row" fxFlexAlign="center"
           class="full-height">
        <app-no-content title="Contest participation has ended!"
                        i18n-title="Contest Exam|Contest ended title@@contest-exam-contest-ended-title"
                        details="Your responses were recorded. You will be able to see results when the contest ends for everyone."
                        i18n-details="Contest Exam|Contest ended details@@contest-exam-contest-ended-details">
        </app-no-content>
      </div>

      <div class="fill-space"></div>

      <div
        *ngIf="!inProgress && contest && taskGrade && !task && !taskLoadFailed && ((contest.startsAt && contest.endsAt && contest.startsAt <= today && contest.endsAt > today && userCanTakePart) || previewMode)"
        class="text-normal-color content-instructions center" ngClass.lt-md="small-screen">
        <p *ngIf="contest.instructions" [innerHTML]="sanitizer.bypassSecurityTrustHtml(contest.instructions)"></p>

        <div class="general-instructions">
          <mat-divider *ngIf="contest.instructions"></mat-divider>
          <h2 class="center-align general-instructions-title"
              i18n="Contest Exam|Contest instructions title@@contest-exam-contest-instructions-title">
            General Instructions
          </h2>
          <ul>
            <li i18n="Contest Exam|Contest instructions option 1@@contest-exam-contest-instructions-option-1">
              You can take the contest only within the defined timeframe;
            </li>
            <li i18n="Contest Exam|Contest instructions option 2@@contest-exam-contest-instructions-option-2">
              You can take the contest only once;
            </li>
            <li i18n="Contest Exam|Contest instructions option 3@@contest-exam-contest-instructions-option-3">
              You can start the contest on one device and continue on another (within the contest duration);
            </li>
          </ul>
        </div>
      </div>

      <div *ngIf="!task" class="language-switch" [class.transparent]="taskType">
        <language-switch theme="dark"></language-switch>
      </div>
    </div>
  </div>
</permission-checker>
